import { useSelector } from "../store"
import { useEffect, useState } from "react"
import { NavigationMenus, iNavigation } from "../api/NavigationMenus"

export function useNavigation() {
  const { user } = useSelector(({ user }) => ({ user }))
  const [filteredPermissions, setPermissions] = useState<Array<iNavigation>>()
  const { permissions } = user

  useEffect(() => {
    setPermissions(filterPermissions(NavigationMenus))
  }, [permissions])

  const filterPermissions = (menu: iNavigation[]): iNavigation[] => {
    const tmp: Array<iNavigation> = []
    for (let i = 0; i < menu.length; i++) {
      const el = menu[i]
      if (el) {
        if (permissions?.find((perm) => perm.name === el.permission)) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
          const { children, ...rest } = el
          tmp.push({ ...rest })
          if (el.children)
            tmp[tmp.length - 1].children = filterPermissions(el.children)
        }
      }
    }
    return tmp
  }

  return filteredPermissions
}
